import { http, authHeader } from '@/http-commons';

// Agregados del Dashboard: el backend agrupa en la base de datos y devuelve DTOs con los importes
// separados por moneda. Las fechas van en `dd-MM-yyyy` (las dos, son obligatorias; maximo 366 dias).
//
// Filtros opcionales: `sucursalId` (solo lo respetan los roles de todas las sucursales; el resto siempre ve la
// suya) y `productoId` (`ventas` y `piezas`). Los vacios no se mandan.
const withFilters = ( params, { sucursalId, productoId } = {} ) => {
    const out = { ...params };
    if( sucursalId ) out.sucursalId = sucursalId;
    if( productoId ) out.productoId = productoId;
    return out;
};

class DashboardDataService {
    ventas( startDate, endDate, filters ){
        return http.get('api/v1/dashboard/ventas', { params: withFilters({ startDate, endDate }, filters), headers: authHeader() });
    }
    // Piezas vendidas y de merma por producto y dia, del rango y de la sucursal del usuario.
    piezas( startDate, endDate, filters ){
        return http.get('api/v1/dashboard/piezas', { params: withFilters({ startDate, endDate }, filters), headers: authHeader() });
    }
    topProductos( startDate, endDate, top = 5, filters ){
        return http.get('api/v1/dashboard/productos/top', { params: withFilters({ startDate, endDate, top }, { sucursalId: filters && filters.sucursalId }), headers: authHeader() });
    }
    compras( startDate, endDate, filters ){
        return http.get('api/v1/dashboard/compras', { params: withFilters({ startDate, endDate }, { sucursalId: filters && filters.sucursalId }), headers: authHeader() });
    }
    // `sucursalId` vacio = todas las sucursales a las que el usuario tiene acceso.
    inventario( sucursalId ){
        const params = sucursalId ? { sucursalId } : {};
        return http.get('api/v1/dashboard/inventario', { params, headers: authHeader() });
    }
    porCobrar( top = 10, filters ){
        return http.get('api/v1/dashboard/por-cobrar', { params: withFilters({ top }, { sucursalId: filters && filters.sucursalId }), headers: authHeader() });
    }
    // 403 si el rol no ve todas las sucursales: la vista lo oculta con CAP.DASHBOARD_TODAS_SUCURSALES_VER.
    // Sin filtros: lo que se debe a proveedores no se reparte por sucursal.
    porPagar( top = 10 ){
        return http.get('api/v1/dashboard/por-pagar', { params: { top }, headers: authHeader() });
    }
}
export default new DashboardDataService();
